import type1 from '@/components/type_questions/type1'
import editor from '@/components/editor'
import type3 from '@/components/type_questions/type3'
import type4 from '@/components/type_questions/type4'

export default {
    data() {
        return {
            questionAnalytic: null
        }
    },
    mounted() {
        document.querySelectorAll('audio').forEach(el => {
            el.addEventListener('canplay', (event) => {
                const timeElement = el.parentNode.querySelector('.audio-time')
                if (timeElement) {
                    timeElement.textContent = `00:00 / ${this.formatSecondsAsTime(event.target.duration)}`;
                }
            })


            el.addEventListener('timeupdate', (event) => {
                const timeElement = el.parentNode.querySelector('.audio-time')
                if (timeElement) {
                    timeElement.textContent = `${this.formatSecondsAsTime(event.target.currentTime)} / ${this.formatSecondsAsTime(event.target.duration)}`;
                }
            })
        })


        document.querySelectorAll('.audio.no-replay button').forEach(e => {

            if (!e.hasAttribute('inited')) {

                e.setAttribute('inited', true)

                e.addEventListener('click', () => {

                    const audio = e.parentNode.parentNode.querySelector('audio')
                    if (audio) {
                        if (e.parentNode.parentNode.classList.contains('play')) {
                            audio.pause()
                            e.parentNode.parentNode.classList.remove('play')
                        } else {
                            if (audio.currentTime == audio.duration && audio.played.length == 1) {
                                return
                            }
                            //stop all audio
                            document.querySelectorAll('.audio.no-replay.play button').forEach(e => {
                                e.click()
                            })
                            audio.play()
                            e.parentNode.parentNode.classList.add('play')
                        }
                    }
                })
            }
            
        })
    },
    components: {
        type1,
        editor,
        type3,
        type4
    },
    computed: {
        Questions(){
            return this.$TestApp.getQuestionOfPart()
        },
        partTitle() {
            return this.Questions.name
        },
    },
    filters: {
        secondToMinute(time) {
            const minute = parseInt(time / 60, 0) < 10 ? `0${parseInt(time / 60, 0)}` : parseInt(time / 60, 0)
            const secord = time % 60 < 10 ? `0${time % 60}` : time % 60
            return `${minute}:${secord}`
        },
    },
    methods: {
        formatSecondsAsTime(secs) {
            var hr  = Math.floor(secs / 3600);
            var min = Math.floor((secs - (hr * 3600))/60);
            var sec = Math.floor(secs - (hr * 3600) -  (min * 60));

            if (min < 10){ 
                min = "0" + min; 
            }
            if (sec < 10){ 
                sec  = "0" + sec;
            }

            return min + ':' + sec;
        },
        nextPartAction () {

            this.questionAnalytic = this.$TestApp.getPartAnalytic()

            this.$bvModal.show('confirm-next')
        },
        toggleNavClass(){
            if(this.navActive == false){
                return 'nav'
            } else {
                return 'sticky-nav'
            }
        },
    }
}